import React, { Component } from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { server } from "redux-server-connection";
import urls from "../../reducers/urls";

import Render from "./Render";

class Register extends Component {
  constructor(props) {
    super(props);
    this.state = { terms: false, error: false };
  }

  toggleTerms() {
    this.setState(state => {
      state.terms = !state.terms;
      return state;
    });
  }

  onSubmit(e) {
    e.preventDefault();
    this.props.sendEmail(e.target[0].value).then(res => {
      if (!res.ok) {
        this.setState(state => {
          state.error = res.data
            ? res.data.message.message
            : "Ocurrio un error";
          return state;
        });
      } else {
        this.props.history.push("/mail-sent");
      }
    });
  }

  render() {
    return (
      <Render
        {...this.props}
        {...this.state}
        toggleTerms={this.toggleTerms.bind(this)}
        onSubmit={this.onSubmit.bind(this)}
      />
    );
  }
}

const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return {
    sendEmail: email =>
      dispatch(server.post(urls.users.register, "USERS", { email }))
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Register)
);



// WEBPACK FOOTER //
// ./src/pages/Register/index.js